// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles-module--breadcrumbs--2xwfr"};